import { type JSX, type SyntheticEvent } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useNavigationHeader } from 'app/hooks';
import { Tabs } from 'app/shared-components/structure';
import type { HealtheraTab } from 'app/shared-components/structure/Tabs';
import FuseSuspense from '@/@fuse/core/FuseSuspense';

const tabs: HealtheraTab[] = [{ label: 'Requested', value: 'requested' }];

const TAB_VALUES = tabs.map((tab) => tab.value);

export default function RxManagementLayout(): JSX.Element {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useNavigationHeader({ title: 'Rx Management', type: 'label' });

  const lastSegment = pathname.split('/').pop() ?? '';
  const selectedTab = TAB_VALUES.includes(lastSegment) ? lastSegment : tabs[0].value;

  const handleTabChange = (_event: SyntheticEvent, newTab: string): void => {
    navigate(`/rx-management/${newTab}`, { replace: true });
  };

  return (
    <main className="vtwo:flex vtwo:min-h-0 vtwo:grow vtwo:flex-col vtwo:gap-4 vtwo:p-4">
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      <FuseSuspense>
        <Outlet />
      </FuseSuspense>
    </main>
  );
}
